import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import PublicPortal from './pages/PublicPortal';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminClients from './pages/AdminClients';
import AdminTestJobs from './pages/AdminTestJobs';
import AdminJobDetail from './pages/AdminJobDetail';
import AdminSettings from './pages/AdminSettings';
import ClientLogin from './pages/ClientLogin';
import ClientDashboard from './pages/ClientDashboard';
import ClientJobDetail from './pages/ClientJobDetail';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicPortal />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
          <Route path="/admin/clients" element={<PrivateRoute><AdminClients /></PrivateRoute>} />
          <Route path="/admin/test-jobs" element={<PrivateRoute><AdminTestJobs /></PrivateRoute>} />
          <Route path="/admin/test-jobs/:jobId" element={<PrivateRoute><AdminJobDetail /></PrivateRoute>} />
          <Route path="/admin/settings" element={<PrivateRoute><AdminSettings /></PrivateRoute>} />
          
          {/* Client Portal Routes */}
          <Route path="/client/login" element={<ClientLogin />} />
          <Route path="/client/dashboard" element={<ClientDashboard />} />
          <Route path="/client/jobs/:jobId" element={<ClientJobDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </>
  );
}

export default App;